import Model from '../Model';
import Mithril from 'mithril';
import LevelConf from './LevelConf';

export default class UserLevel extends Model {
  userId() {
    return Model.attribute<number>('userId').call(this);
  }
  level() {
    return Model.attribute<number>('level').call(this);
  }
  allExperiences() {
    return Model.attribute<number>('allExperiences').call(this);
  }
  addExperiences() {
    return Model.attribute<number>('addExperiences').call(this);
  }
  createTime() {
    return Model.attribute('createTime', Model.transformDate).call(this);
  }
  updateExperiencesTime() {
    return Model.attribute('updateExperiencesTime', Model.transformDate).call(this);
  }
  updateLevelTime() {
    return Model.attribute('updateLevelTime', Model.transformDate).call(this);
  }
  signInTime() {
    return Model.attribute('signInTime', Model.transformDate).call(this);
  }
  allIntegra() {
    return Model.attribute<number>('allIntegra').call(this);
  }
  addIntegra() {
    return Model.attribute<number>('addIntegra').call(this);
  }
  signInDays() {
    return Model.attribute<number>('signInDays').call(this);
  }
  updateIntegraTime() {
    return Model.attribute('updateIntegraTime', Model.transformDate).call(this);
  }
  levelConf() {
    return Model.hasOne<LevelConf | null>('levelConf').call(this);
  }


  


  /**
   * Update the user's preferences.
   */
  // savePreferences(newPreferences: Record<string, unknown>): Promise<this> {
  //   const preferences = this.preferences();

  //   Object.assign(preferences ?? {}, newPreferences);

  //   return this.save({ preferences });
  // }
}
